/* tslint:disable */
/* eslint-disable */
/**
 * API
 * This document specifies the application programming interface (API) for Hellewi.  # URL format  `https://api.<domain>/<version>/<tenant>/<language>/<endpoint>`  e.g. `https://api.opistopalvelut.fi/v1/demo/fi/courses`  - protocol: `https` ssl must be used. - domain: `opistopalvelut.fi` domain should be the same as with tenant\'s   admin and registration domain (i.e. not necessarily opistopalvelut.fi). - version: `v1` marks the API version, only v1 is supported. - tenant: `demo` is the tenant name, should be the same as with   admin/registration url - language: `fi` is language selection, options fi/en/sv are supported - endpoint: `courses` api endpoint  Tenant must be given also inside [JWT](#section/Authentication/JWT), and it must match the tenant/domain in URL.  ## Multi-tenant request  `https://api.linnunrata.fi/<version>/<language>/<endpoint>`  e.g. `https://api.linnunrata.fi/v1/fi/courses`  This will search for courses from all the tenants that the used api key can access. All endpoints do not support multi-tenancy, those that do are listed under tag [MultiTenant](#tag/MultiTenant).  # Testing API  - url: `https://api.opistopalvelut.fi/v1/demo/fi/` - api key: `demo` - secret: `salasana`  Testing API can access only the demo tenant (\"database\" or \"client\"). You can however access multiple tenants with the same API key depending on your license.  # Search  Search query API follows [GitHub Search](https://developer.github.com/v3/search) closely.  Search string is in format `?q=SEARCH_TERM_1+SEARCH_TERM_N+FILTER_1+FILTER_N`, e.g. search terms and filters combined with `+` signs or url-encoded spaces `%20`.  Search terms are keywords to be searched. Disallowed characters are: `: + \" \'`. Results are sorted by default based on matching: best matching entries first.  ### Filters  Filters are in format `field:value`. In this simplest case, the field must be equal to the given value.  If there are multiple filters defined, results must match *all* different filters. If there are multiple filter values for the same field, results must match *one* of those. For example: `?q=department:3+subject:1+subject:2` means that all courses with department 3 and subject 1 or 2.  ### Filter operators  Supported operators in filters: - `:` equality, for example: `subject:1` - `:!` not, for example: `department:!2` - `:<` less than, for example: `distancesoft:<10km` - `:<=` less than or equal, for example: `ends:<=2020-02-01` - `:>` greater than, for example: `begins:>2019-01-01` - `:>=` greater than or equal, for example: `begins:>=2019-01-01`  ## Pagination  Pagination is handled with response headers.  Unfortunately these are not included in swagger.json due to technical restrictions in the spec generation.  ### link  `link` follows [RFC5988](https://tools.ietf.org/html/rfc5988#section-5) and [GitHub pagination](https://developer.github.com/v3/guides/traversing-with-pagination/): there are at most four links:   - `rel=\"first\"` gives the first page of results with current filters   - `rel=\"prev\"` previous page   - `rel=\"next\"` next page   - `rel=\"last\"` last page  For example (linefeeds added):      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      link: <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=1&limit=2>; rel=\"first\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=4&limit=2>; rel=\"prev\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=6&limit=2>; rel=\"next\",           <https://api.opistopalvelut.fi/v1/demo/fi/courses?page=14&limit=2>; rel=\"last\"  If the query is for the first page, first and prev are omitted. Similarly, if the query is for the last page, last and next are omitted.  If there are no results, all links are omitted.  The link-header should be used for creating pagination functionality.  ### x-total-count  `x-total-count` is the total number of items in result set.  For example:      GET https://api.opistopalvelut.fi/v1/demo/fi/courses?page=5&limit=2      x-total-count: 29  The maximum number here is 10000. If you are expecting a bigger number, or are interested only in the total course count and not the results itself, you should be using [GetCourseCount](#operation/GetCourseCount).  ## Course search  Field explanations by name can be found from [ListCourses](#operation/ListCourses) response schema.  ### Search term  Search term matches text in following course fields with relative weights in parenthesis:  - name (10) - code (7) - teacher (5) - subject (4) - location (3) - category (2) - description (1)  Search terms can have multiple words combined with double quotation marks `\"`.  For example:  `?q=jooga` search term \"jooga\" (probably in course name)  `?q=830107+\"dynaaminen jooga\"` search terms \"830107\" and \"dynaaminen jooga\"  ### Equality filters by id  - category - classification - department - educationsector - language - levelofstudy - location - moduleparent (also null works) - period - subject - tag - tenant - term - weekday  Category can be queried with a path \"department/category\" and subject with \"department/category/subject\" or \"category/subject\".  Tenant makes sense only in the context of multi-tenant requests.  For example:  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `q=weekday:1` courses that have lessons on Monday  `q=moduleparent:18` module child courses that have parent course 18  `q=moduleparent:null` all courses that are not module child courses  ### Date filters  - begins (date-only, YYYY-MM-DD) - ends (date-only, YYYY-MM-DD) - registrationbegins (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendssoft (date-time, YYYY-MM-DDTHH:MM:SSZ) - registrationendshard (date-time, YYYY-MM-DDTHH:MM:SSZ)  For example:  `?q=begins:>=2019-01-01`: courses that begin after or on 1.1.2019  ### Distance filters  - distancefrom (origin coordinates: \\<latitude\\>,\\<longitude\\>) - distancehard (distance: \\<number\\>km or \\<number\\>m), if course\'s   location is farther, course will not be included in results - distancesoft (distance: \\<number\\>km or \\<number\\>m), will return all   courses ordered by distance, courses farther than this distance will   be ranked considerably lower (but if only this filter is used, value   can be anything)  distancefrom must be given if either filter is used. Only less than operator `:<` is supported for distancehard and distancesoft.  For example:  `?q=distancefrom:60.169,24.944+distancehard:<50km+distancesoft:<10km`: courses that are closer than 50km from 60.169,24.944, ordered by proximity  ### Other filters  - registrationopen (boolean, only true supported)  registration is currently open. See rules in [Registration](#section/Registration).  For example:  `?q=registrationopen:true`: courses where registration is open currently  ### Distance learning (etäopetus)  Distance learning courses have a special location `distancelearning`:  `?q=location:distancelearning`: only distance learning courses  `?q=location:!distancelearning`: only non-distance learning (lähiopetus) courses  ### Additional examples  `?q=jooga+category:2`: search term \"jooga\" in category 2 courses  `?q=department:3+subject:1+subject:2` all courses with department 3 *and* subject 1 *or* 2  `?q=jooga+begins:>=2019-01-01` search term \"jooga\" in courses that begin after or on 1.1.2019  # Registration  Deciding whether you can register to a course follows these rules that are compared in order (i.e. when a rule matches, the rest are not evaluated): 1. current time < course.registrationbegins: **registration IS NOT open**<br>    Registration is not yet started. 2. course.ends < current time: **registration IS NOT open**<br>    Course has already ended. If course ending time is not defined, this    step is skipped. 3. current time < course.registrationendshard: **registration IS open**<br>    Registration is not yet ended. 4. otherwise: **registration IS NOT open**  Admin interface has only one time for registration ending. It also has a global setting for making that ending time either a soft or hard deadline. API registrationendshard takes this global setting into account (it will be null if registrationends is a soft deadline). Also, if registration beginning or ending time is undefined in admin interface, they will be null in API (i.e. registrationbegins null => registration not open, registrationends null => registration is open).  ## Registration to lessons  Some courses can have registration to single or multiple lessons in addition to registration to the whole course. Registering to lessons can be enabled from admin interface, and is possible if registration to the course is open, and if there is available places in that lesson.  Selecting a price means that registration is for the whole course, where selecting lessons means that registration is only for the specified lessons. Both options are not always present, they follow these rules:  1. If course has registration to lessons (\"registration practice\" /    \"ilmoittautumistapa: ilmoittautuminen kerroille\") and lessons defined,    lessons can be selected. 2. If registration to lessons is restricted (\"lesson registration limit\" /    \"kuinka monelle seuraavalle kerralle voi ilmoittautua\"), prices cannot    be selected. 3. If registration to lessons doesn\'t cost anything (\"single lesson fee\" /    \"kertamaksu\" 0,00 e) and all course prices are also zero, prices (and    lessons) can be selected. 4. If registration to lessons cost something and all course prices are    *not* zero, prices (and lessons) can be selected. 5. If course doesn\'t have any prices and registration to lessons is free,    leaving lessons empty is also allowed, which means that the registration    is for the whole course.  Note that even when prices and lessons are both selectable, user cannot select both at the same time.  Registration to lessons\' spare places is not possible.  ## Selecting installments  Prices can have one or more installment groups that can be selected as payment option. Installment options can also expire so that for example course has separate installments for fall and spring period, and fall installment is only valid until the change of period.  Course can have prices with installments and prices without installments at the same time. If a course price has installments, selecting one is required.  ## How price is calculated  1. Lessons selected: price will be the price of combined lessons 2. Spare place: price for a spare place course is always zero 3. Installments selected: price that can or has to be paid after registration    will be the price of the first installment, other installments will be    billed later 4. Otherwise: price will be the selected price  # Rate limit  Requests to API are rate limited to 100 requests per 10 seconds. When this rate limit is exceeded, API will respond with HTTP status code 429 too many requests.  # JWT authentication  Required fields for header are: - `typ` must always be \'JWT\' - `alg` JWT signing algorithm, supported algorithms are: \'HS256\',   \'HS384\' and \'HS512\' - `kid` API key (*not* secret), \'demo\' can be used for testing with   demo data  Required fields for payload are: - `sub` subject, must be \'hellewi-api-v1\' for this API - `iat` issued at (unix timestamp) - `exp` expiration time (unix timestamp). Maximum expiration time is   one week in the future. When using key id \'demo\', this is not   enforced. - `tenant` tenant identifier, this is in format `<tenant>.<domain>`,   e.g. for opistopalvelut.fi/demo tenant is demo.opistopalvelut.fi - `jti` JWT id, unique identifier, used for identifying sessions. This   must be a random string.  More information about JWTs and an excellent tool for generating JWT tokens for testing can be found at [jwt.io](https://jwt.io).  JWT formatting can be tested against [JWT status endpoint](#operation/GetStatusJwt)  For simple authentication testing, here is a ready-made JWT:  Header: ```json {   \"alg\": \"HS256\",   \"typ\": \"JWT\",   \"kid\": \"demo\" } ```  Payload: ```json {   \"iat\": 1516239022,   \"exp\": 2524608000,   \"sub\": \"hellewi-api-v1\",   \"tenant\": \"demo.opistopalvelut.fi\",   \"jti\": \"ahtu0aiWo4aMooshie9waethae7cuaj0ua2uichieshaevee3j\" } ```  Secret: `salasana`  Encoded (linefeeds added): ```markup eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1 MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktYXBpLXYxIiwidGVuYW50IjoiZGVtby5vcGl zdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFodHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2 N1YWowdWEydWljaGllc2hhZXZlZTNqIiwiZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7Vm LCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g ```  Shell command: ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" https://api.opistopalvelut.fi/v1/demo/fi/status/jwt ```  # HMAC request signing  JWT authentication is used on server to server communication, but sometimes there is a need for authenticating requests that originate from user\'s browser, such as viewing previously done registrations.  Note that the signed request links must be generated in a backend service as the signing uses api secret which must not be given to users.  Fields used for HMAC calculation, example from [GetStatusHmac](#operation/GetStatusHmac):   - all request parameters *except* `hmac`:     - `reqid`: random UUIDv4 string, e.g.       \'9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d\'     - `expiry`: expiration time in ISO8601 format, e.g.       \'2023-06-15T06:00:00Z\'     - there probably are also other parameters, depending on the endpoint   - two additional parameters that are *not* in the actual request:     - `scope`: endpoint HMAC scope, this is show in each endpoint\'s       authorizations-section and start with \'hmac-\',       e.g. \'hmac-status-required\'     - `tenant`: same tenant string as is used in JWT authentication,       e.g. \'demo.opistopalvelut.fi\'  All listed parameters are then ordered alphabetically and url-encoded as if they were normal query parameters (linefeed added):  ```markup expiry=2023-06-15T06%3A00%3A00Z&reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d& scope=hmac-status-required&tenant=demo.opistopalvelut.fi ```  Then HMAC digest is calculated with SHA-256 using api secret. Above with secret `salasana`:  ```markup 88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  This is used as the request `hmac` parameter value.  So after all the request is (linefeeds added): ```markup https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a ```  HMAC can be tested against [HMAC status endpoint](#operation/GetStatusHmac). JWT must be used there as well:  ```bash curl -v -H \"Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXV CIsImtpZCI6ImRlbW8ifQ.eyJpYXQiOjE1MTYyMzkwMjIsInN1YiI6ImhlbGxld2ktY XBpLXYxIiwidGVuYW50IjoiZGVtby5vcGlzdG9wYWx2ZWx1dC5maSIsImp0aSI6ImFo dHUwYWlXbzRhTW9vc2hpZTl3YWV0aGFlN2N1YWowdWEydWljaGllc2hhZXZlZTNqIiw iZXhwIjoyNTI0NjA4MDAwfQ.BhzoUPL7VmLCsrtTaZ2yyPIljYNZEiUyoayqRYchm3g\" \"https://api.opistopalvelut.fi/v1/demo/fi/status/hmac ?expiry=2023-06-15T06%3A00%3A00Z &reqid=9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d &hmac=88290d424fa7bc11afc22140346ba3f3fa0552bff121fb6fb63c60deec7b796a\" ```  ## Node.js implementation  Uses `date-fns` and `uuid` external libraries, and node.js `crypto`.  ```javascript import { createHmac } from \'crypto\'; import { addYears } from \'date-fns\'; import { v4 as uuidv4 } from \'uuid\';  const HMAC_ALGORITHM = \'sha256\'; const API_SECRET = \'salasana\'; // use proper secret handling  const queryParamsWithoutHmac = {   // use shorter expiration   expiry: addYears(new Date(), 2).toISOString(),   reqid: uuidv4() };  const hmacCalculationParams = {   ...queryParamsWithoutHmac,   scope: \'hmac-status-required\',   tenant: \'demo.opistopalvelut.fi\' };  const hmacCalculationURLSearchParams = new URLSearchParams(   hmacCalculationParams ); hmacCalculationURLSearchParams.sort();  const hmac = createHmac(HMAC_ALGORITHM, API_SECRET)   .update(hmacCalculationURLSearchParams.toString())   .digest(\'hex\');  const queryParams = {   ...queryParamsWithoutHmac,   hmac };  const urlSearchParams = new URLSearchParams(queryParams);  console.log(queryParams); console.log(urlSearchParams.toString()); ```  Prints out: ```markup {   reqid: \'09d1eb20-1b84-4af6-935b-6de0db0b3e75\',   expiry: \'2024-01-05T10:32:50.646Z\',   hmac: \'27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987\' } reqid=09d1eb20-1b84-4af6-935b-6de0db0b3e75&expiry=2024-01-05T10%3A32%3A50.646Z&hmac=27d7d2d4136f9e4962a6058296864f15985f81086d145ae687075ce60510c987 ``` 
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: perttu.tikka@hellewi.fi
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HellewiCatalogItem } from './HellewiCatalogItem';
import {
    HellewiCatalogItemFromJSON,
    HellewiCatalogItemFromJSONTyped,
    HellewiCatalogItemToJSON,
} from './HellewiCatalogItem';

/**
 * Catalog with all different CatalogItems grouped and sorted
 * @export
 * @interface HellewiCatalog
 */
export interface HellewiCatalog {
    [key: string]: any | any;
    /**
     * Department
     * 
     * These are configurable by tenant, and they usually contain for example the
     * city which organizes the courses (e.g. Tampere, Ylöjärvi, Kuru, Viljakkala).
     * 
     * Department, Category and Subject form a tree: a category's parent is always
     * a department (or undefined), and subject's parent is always a category
     * (or undefined).
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    department: Array<HellewiCatalogItem>;
    /**
     * Category
     * 
     * Higher-level course categorisation. These are for example arts, languages,
     * health and such.
     * 
     * These are also configurable by tenant, so different tenant's categories
     * are not comparable with each others.
     * 
     * Category can have department as parent, and it can have multiple subjects
     * as children.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    category: Array<HellewiCatalogItem>;
    /**
     * Subject
     * 
     * Lower-level course categorisation. These are for example English, French,
     * German under languages-category.
     * 
     * Subject's parent is a category (if any).
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    subject: Array<HellewiCatalogItem>;
    /**
     * Course type
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    coursetype: Array<HellewiCatalogItem>;
    /**
     * Classification
     * 
     * High level classification of courses. These are based on education sectors.
     * 
     * These are static for all the tenants, and can be used when combining data
     * from multiple tenants.
     * 
     * Education sectors are classified the following way (itcode and
     * educationsector's name):
     * 
     * **1: Sports and wellness / Liikunta ja hyvinvointi / Motion och välmående**
     * 
     * - 752 Liikunta ja urheilu
     * - 799 Muu sosiaali-, terveys- ja liikunta-alan koulutus
     * - 751 Terveysala ja hammashuolto
     * - 101 Vapaa-aika- ja nuorisotyö
     * 
     * **2: Crafts / Käsityö / Hantverk**
     * 
     * - 201 Käsi- ja taideteollisuus ja käden taidot
     * - 508 Tekstiili- ja vaatetusala
     * 
     * **3: Languages / Kielet / Språk**
     * 
     * - 10201 Kielitiede
     * - 10202 Suomi
     * - 10203 Ruotsi
     * - 10204 Englanti
     * - 10205 Saksa
     * - 10206 Ranska
     * - 10207 Venäjä
     * - 10208 Espanja
     * - 10209 Italia
     * - 10299 Muut kielet
     * 
     * **4: Music / Musiikki / Musik**
     * 
     * - 205 Musiikki
     * 
     * **5: Arts / Kuvataide / Bildkonst och formgivning**
     * 
     * - 206 Kuvataide
     * 
     * **6: Dance and theater / Tanssi ja teatteri / Dans och teater**
     * 
     * - 204 Teatteri ja tanssi
     * 
     * **7: Technology and business / Tekniikka ja talous / Teknik och ekonomi**
     * 
     * - 40201 Tietokoneen ajokorttikoulutus
     * - 40299 Muu tietotekniikan hyväksikäyttö
     * - 504 Tieto- ja tietoliikennetekniikka
     * - 505 Graafinen ja viestintätekniikka
     * - 202 Viestintä- ja informaatioala
     * - 301 Liiketalous ja kauppa
     * - 351 Yrittäjyys ja yrittäjyyskasvatus
     * - 302 Kansantalous
     * - 304 Tilastointi ja tilastotiede
     * - 401 Matematiikka
     * - 451 Fysiikka ja kemia sekä geo-, avaruus- ja tähtitiet
     * - 452 Biologia ja maantiede
     * - 499 Muu luonnontietteiden alan koulutus
     * - 501 Arkkitehtuuri ja rakentaminen
     * - 502 Kone-, metalli- ja energiatekniikka
     * - 503 Sähkö- ja automaatiotekniikka
     * - 506 Elintarvikeala ja biotekniikka
     * - 507 Prosessi-, kemian ja materiaalitekniikka
     * - 509 Ajoneuvo- ja kuljetusala
     * - 510 Tuotantotalous
     * - 599 Muu tekniikan ja liikenteen alan koulutus
     * 
     * **8: Society and humanities / Yhteiskunta ja humanismi / Samhälle och humaniora**
     * 
     * - 203 Kirjallisuus
     * - 207 Kulttuurin- ja taiteiden tutkimus
     * - 151 Opetus- ja kasvatustyö ja psykologia
     * - 103 Historia ja arkeologia
     * - 199 Muu humanistisen ja kasvatusalan koulutus
     * - 399 Muu yhteiskunnallisten aineiden, liiketalouden ja
     * - 104 Filosofia
     * - 107 Teologia
     * - 305 Sosiaalitieteet
     * - 306 Politiikka ja politiikkatieteet
     * - 307 Oikeuskäytäntö ja oikeustieteet
     * 
     * **9: Nature and environment / Luonto ja ympäristö / natur och miljö**
     * 
     * - 602 Puutarhatalous ja puutarhanhoito
     * - 605 Luonto- ja ympäristöala
     * - 651 Maatila- ja metsätalous
     * - 603 Kalatalous ja kalastus
     * - 699 Muu luonnonvara- ja ympäristöalan koulutus
     * 
     * **10: Food, drink and travel / Ruoka, juoma ja matkailu / Mat, dryck och resor**
     * 
     * - 802 Majoitus- ja ravitsemisala sekä ruoan valmistus
     * - 851 Kotitalous- ja kuluttajapalvelut sekä puhdistus
     * - 801 Matkailuala
     * - 899 Muu matkailu-, ravitsemis- ja talousalan koulutus
     * 
     * **99: Others / Muut / Övriga**
     * 
     * - 999 Muu koulutus
     * - 99 Muu yleissivistävä koulutus
     * - 2 Perusopetus
     * - 3 Lukiokoulutus
     * - 51 Oppimisvalmiuksien kehittäminen ja motivointi
     * - 299 Muu kulttuurialan koulutus
     * - 30301 Kansalais- ja järjestötoiminta
     * - 30399 Muu hallinnon alan koulutus
     * - 701 Sosiaaliala
     * - 753 Farmasia ja muu lääkehuolto sekä tekniset terveysp
     * - 709 Eläinlääketiede
     * - 710 Kauneudenhoitoala
     * - 901 Sotilas- ja rajavartioala
     * - 902 Palo- ja pelastusala
     * - 951 Poliisi- ja vartiointiala
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    classification: Array<HellewiCatalogItem>;
    /**
     * Education sector (koulutusala)
     * 
     * Lower level course categorisation. This follows the Statistics Finland's
     * [National Classification of Education](https://www.stat.fi/fi/luokitukset/koulutus),
     * although an older version of it.
     * 
     * Education sector's parent is a classification
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    educationsector: Array<HellewiCatalogItem>;
    /**
     * Education type
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    educationtype: Array<HellewiCatalogItem>;
    /**
     * Level of study
     * 
     * These are levels for how courses compare with each others, e.g. beginner,
     * intermediate, advanced. For language courses for example, the level of
     * study can follow CEFR levels A1, A2, B1, etc.
     * 
     * These are configurable by the tenant, so different tenant's categories are
     * not comparable with each others.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    levelofstudy: Array<HellewiCatalogItem>;
    /**
     * Teaching format
     * 
     * Teaching format of the course.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    teachingformat: Array<HellewiCatalogItem>;
    /**
     * Language
     * 
     * Language used in the course.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    language: Array<HellewiCatalogItem>;
    /**
     * Location
     * 
     * Where course is held.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    location: Array<HellewiCatalogItem>;
    /**
     * Locationgroup
     * 
     * Where course is held.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    locationgroup: Array<HellewiCatalogItem>;
    /**
     * Term (lukuvuosi)
     * 
     * Years in education usually start in the autumn and continue until summer.
     * Term is this time period, usually divided into autumn and spring semesters
     * (catalog item period).
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    term: Array<HellewiCatalogItem>;
    /**
     * Period (lukukausi)
     * 
     * Courses usually have a certain period during which they are held. There are
     * usually two periods during a term: autumn and spring (syys- ja kevätlukukausi).
     * 
     * Period's parent is a term.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    period: Array<HellewiCatalogItem>;
    /**
     * Tag
     * 
     * Custom tag for a course, these can be defined by the tenant.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    tag: Array<HellewiCatalogItem>;
    /**
     * Tenant
     * 
     * Tenant that is organizing the courses. This makes only in multi-tenant context,
     * in single-tenant there will be only one tenant here.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    tenant: Array<HellewiCatalogItem>;
    /**
     * Unit
     * 
     * Unit that is organizing the course.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    unit: Array<HellewiCatalogItem>;
    /**
     * Weekday
     * 
     * On which day(s) the course is held.
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    weekday: Array<HellewiCatalogItem>;
    /**
     * Date
     * 
     * Filters for courses dates
     * @type {Array<HellewiCatalogItem>}
     * @memberof HellewiCatalog
     */
    date: Array<HellewiCatalogItem>;
}

/**
 * Check if a given object implements the HellewiCatalog interface.
 */
export function instanceOfHellewiCatalog(value: object): boolean {
    if (!('department' in value)) return false;
    if (!('category' in value)) return false;
    if (!('subject' in value)) return false;
    if (!('coursetype' in value)) return false;
    if (!('classification' in value)) return false;
    if (!('educationsector' in value)) return false;
    if (!('educationtype' in value)) return false;
    if (!('levelofstudy' in value)) return false;
    if (!('teachingformat' in value)) return false;
    if (!('language' in value)) return false;
    if (!('location' in value)) return false;
    if (!('locationgroup' in value)) return false;
    if (!('term' in value)) return false;
    if (!('period' in value)) return false;
    if (!('tag' in value)) return false;
    if (!('tenant' in value)) return false;
    if (!('unit' in value)) return false;
    if (!('weekday' in value)) return false;
    if (!('date' in value)) return false;
    return true;
}

export function HellewiCatalogFromJSON(json: any): HellewiCatalog {
    return HellewiCatalogFromJSONTyped(json, false);
}

export function HellewiCatalogFromJSONTyped(json: any, ignoreDiscriminator: boolean): HellewiCatalog {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'department': ((json['department'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'category': ((json['category'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'subject': ((json['subject'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'coursetype': ((json['coursetype'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'classification': ((json['classification'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'educationsector': ((json['educationsector'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'educationtype': ((json['educationtype'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'levelofstudy': ((json['levelofstudy'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'teachingformat': ((json['teachingformat'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'language': ((json['language'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'location': ((json['location'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'locationgroup': ((json['locationgroup'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'term': ((json['term'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'period': ((json['period'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'tag': ((json['tag'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'tenant': ((json['tenant'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'unit': ((json['unit'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'weekday': ((json['weekday'] as Array<any>).map(HellewiCatalogItemFromJSON)),
        'date': ((json['date'] as Array<any>).map(HellewiCatalogItemFromJSON)),
    };
}

export function HellewiCatalogToJSON(value?: HellewiCatalog | null): any {
    if (value == null) {
        return value;
    }
    return {
        
            ...value,
        'department': ((value['department'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'category': ((value['category'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'subject': ((value['subject'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'coursetype': ((value['coursetype'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'classification': ((value['classification'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'educationsector': ((value['educationsector'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'educationtype': ((value['educationtype'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'levelofstudy': ((value['levelofstudy'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'teachingformat': ((value['teachingformat'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'language': ((value['language'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'location': ((value['location'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'locationgroup': ((value['locationgroup'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'term': ((value['term'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'period': ((value['period'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'tag': ((value['tag'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'tenant': ((value['tenant'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'unit': ((value['unit'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'weekday': ((value['weekday'] as Array<any>).map(HellewiCatalogItemToJSON)),
        'date': ((value['date'] as Array<any>).map(HellewiCatalogItemToJSON)),
    };
}

